export default from './upload-image-button';



// WEBPACK FOOTER //
// ./app/components/upload-image-button/index.js